
  import {Component, Vue, Watch} from "vue-property-decorator";
  import VoucherService from "../../services/voucher.service";
  import VoucherDialog from "./../voucher/dialogs/VoucherDialog.vue";
  import LoadingOverlay from "../core/LoadingOverlay.vue";
  import {Voucher} from "../../models/voucherI";
  import EnterVoucherExportDateDialog from "./dialogs/EnterVoucherExportDateDialog.vue";

  @Component({
    components: {EnterVoucherExportDateDialog, VoucherDialog, LoadingOverlay}
  })
  export default class VoucherTracking extends Vue {

    selectedVoucher = [];
    voucherDetailsDialogVisible = false;
    vouchersTableData: Voucher[] = [];
    selectedVoucherForDetails: any = null;

    private showOverlay = false;

    private menu1 = false;
    private voucherDatumVonFilterValue = null;
    private voucherDatumVonFormatted: any | null = "";

    private menu2 = false;
    private voucherDatumBisFilterValue = null;
    private voucherDatumBisFormatted: any | null = "";

    rechnungAttachments = "";

    private gesamtBetragVonFilterValue = "";
    private gesamtBetragBisFilterValue = "";

    private rechnungnrFilterValue = "";
    private vendorNameFilterValue = "";
    private paymentVendorNameFilterValue = "";
    private departmentFilterValue = "";
    private voucherExportDialogVisible = false;


    vouchersTableHeaders = [
      {text: 'Voucher-Nr', value: 'id'},
      {text: 'Vendor-Name', value: 'vendorName', filter: this.vendorNameFilter},
      {text: 'Payment Vendor-Name', value: 'paymentVendorName', filter: this.paymentVendorNameFilter},
      {text: 'Abteilung', value: 'department', filter: this.departmentFilter},
      {text: 'Betrag', value: 'gesamtBetrag', filter: this.gesamtBetragFilter},
      {text: 'Voucher-Datum', value: 'createDate', filter: this.voucherDatumFilter},
      {text: 'Details', value: 'details', sortable: false, filterable: false, align: 'center'},
    ];

    beforeMount() {
      this.loadVouchers(false);
    }

    formatDate(date: any) {
      if (!date) {
        return null;
      }
      const [year, month, day] = date.split('-');

      return `${day}.${month}.${year}`;
    }

    parseDate(date: any) {
      if (!date) {
        return null;
      }
      const [day, month, year] = date.split('.');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }

    @Watch('voucherDatumVonFilterValue')
    onPropertyChanged1(value: string, oldValue: string) {
      this.voucherDatumVonFormatted = this.formatDate(this.voucherDatumVonFilterValue);
    }

    @Watch('voucherDatumBisFilterValue')
    onPropertyChanged2(value: string, oldValue: string) {
      this.voucherDatumBisFormatted = this.formatDate(this.voucherDatumBisFilterValue);
    }

    @Watch('voucherDetailsDialogVisible')
    onPropertyChanged5(value: string, oldValue: string) {
    }

    rechnungnrFilter(valueInRow: any) {
      if (!this.rechnungnrFilterValue) {
        return true;
      }
      return (valueInRow.toUpperCase().indexOf(this.rechnungnrFilterValue.toUpperCase()) >= 0);
    }

    vendorNameFilter(valueInRow: any) {
      if (!this.vendorNameFilterValue) {
        return true;
      }
      return (valueInRow.toUpperCase().indexOf(this.vendorNameFilterValue.toUpperCase()) >= 0);
    }

    paymentVendorNameFilter(valueInRow: any) {
      if (!this.paymentVendorNameFilterValue) {
        return true;
      }
      if (!valueInRow) {
        return false;
      }
      return (valueInRow.toUpperCase().indexOf(this.paymentVendorNameFilterValue.toUpperCase()) >= 0);
    }

    departmentFilter(valueInRow: any) {
      if (!this.departmentFilterValue) {
        return true;
      }
      if (!valueInRow) {
        return false;
      }
      return (valueInRow.toUpperCase().indexOf(this.departmentFilterValue.toUpperCase()) >= 0);
    }

    voucherDatumFilter(valueInRow: any) {
      if ((!this.voucherDatumVonFilterValue || this.voucherDatumVonFilterValue == "")
        && (!this.voucherDatumBisFilterValue || this.voucherDatumBisFilterValue == "")) {
        return true;
      }
      if (this.voucherDatumVonFilterValue && !this.voucherDatumBisFilterValue) {
        //@ts-ignore
        var dateParts = this.voucherDatumVonFilterValue.split("-");
        var dateObjectVon = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2]);
        dateParts = valueInRow.substring(0, 10).split("-");
        var dateObjectValueInRow = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2]);
        return dateObjectValueInRow >= dateObjectVon;
      }
      if (!this.voucherDatumVonFilterValue && this.voucherDatumBisFilterValue) {
        //@ts-ignore
        var dateParts = this.voucherDatumBisFilterValue.split("-");
        var dateObjectBis = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2]);
        dateParts = valueInRow.substring(0, 10).split("-");
        var dateObjectValueInRow = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2]);
        return dateObjectValueInRow <= dateObjectBis;
      }
      if (this.voucherDatumVonFilterValue && this.voucherDatumBisFilterValue) {
        //@ts-ignore
        var dateParts = this.voucherDatumVonFilterValue.split("-");
        var dateObjectVon = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2]);
        //@ts-ignore
        dateParts = this.voucherDatumBisFilterValue.split("-");
        var dateObjectBis = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2]);

        dateParts = valueInRow.substring(0, 10).split("-");
        var dateObjectValueInRow = new Date(+dateParts[0], dateParts[1] - 1, +dateParts[2]);

        if (dateObjectValueInRow >= dateObjectVon && dateObjectValueInRow <= dateObjectBis) {
          return true;
        } else {
          return false;
        }
      }

      return valueInRow.substring(0, 10) === this.voucherDatumVonFilterValue;
    }

    gesamtBetragFilter(valueInRow: any) {
      if (!this.gesamtBetragVonFilterValue && !this.gesamtBetragBisFilterValue) {
        return true;
      }
      if (this.gesamtBetragVonFilterValue && !this.gesamtBetragBisFilterValue) {
        return valueInRow >= this.gesamtBetragVonFilterValue.replace(",", ".");
      }
      if (!this.gesamtBetragVonFilterValue && this.gesamtBetragBisFilterValue) {
        return valueInRow <= this.gesamtBetragBisFilterValue.replace(",", ".");
      }
      if (this.gesamtBetragVonFilterValue && this.gesamtBetragBisFilterValue) {
        if (valueInRow >= this.gesamtBetragVonFilterValue.replace(",", ".") && valueInRow <= this.gesamtBetragBisFilterValue.replace(",", ".")) {
          return true;
        } else {
          return false;
        }
      }
    }

    handleCloseDetailsDialog() {
      this.voucherDetailsDialogVisible = false;
      this.loadVouchers(true);
    }

    loadVouchers(force: boolean) {
      this.showOverlay = true;
      VoucherService.getVoucherArchive()
        .then(
          (response: any) => {
            this.vouchersTableData = response.data;
            this.showOverlay = false;
          })
        .catch((error: any) => {
          this.$notify({
            group: 'foo',
            title: 'Fehler',
            text: error,
            type: 'error'
          });
          this.showOverlay = false;
        })
        .finally(() => {
          setTimeout(() => {
            this.showOverlay = false;
          }, 5000);
        });
    }

    private reloadVouchers() {
      this.loadVouchers(true);
    }

    handleDetails(selectedVoucher: any) {
      this.selectedVoucherForDetails = Object.assign({}, selectedVoucher);
      this.voucherDetailsDialogVisible = true;
    }

    resetFilter() {
      window.location.reload();
    }

    private showVoucherExportDialog() {
      this.voucherExportDialogVisible = true;
    }

    private handleCloseVoucherDataExportDialog() {
      this.voucherExportDialogVisible = false;
    }
  }
